<template>
  <b-container fluid>
        <b-row>
            <b-col cols="12" md="4">
                <div class="login__description">
                    <div>
                        <h3>
                            <img :src="$cdn + '/icons/icon-person-login.svg'" alt="icono persona">
                            Renovar usuario
                        </h3>
                        <p>Ingresa la nueva contraseña para renovar el usuario</p>
                    </div>
                </div>
            </b-col>
            <b-col cols="12" md="4">
                <div class="login__form">
                    <div class="login__paragraph">
                        <p>Completa la siguiente información:</p>
                    </div>
                    <div>
                        <div class="labels">
                            <label for="emailNew">Contraseña nueva</label>
                        </div>
                        <div class="inputs password mb-3">
                            <input v-model="emailNew" type="password" id="emailNew">
                            <button class="show" @click="verClave()">
                                <b-icon icon="eye-fill"></b-icon>
                                <b-icon icon="eye-slash-fill"></b-icon>
                            </button>
                        </div>
                    </div>
                    <div>
                        <div class="labels">
                            <label for="emailNew2">Confirmacion de contraseña nueva</label>
                        </div>
                        <div class="inputs password mb-5">
                            <input v-model="emailNew2" type="password" id="emailNew2">
                            <button class="show" @click="verClave2()">
                                <b-icon icon="eye-fill"></b-icon>
                                <b-icon icon="eye-slash-fill"></b-icon>
                            </button>
                        </div>
                    </div>
                    <button class="button-principal" @click="$router.push('/login')">Actualizar contraseña</button>
                </div>
            </b-col>
            <b-col>
                <div class="login__logo">
                    <img :src="$cdn + '/logos/logo-Cajasan-azul-slogan.png'" alt="Logo Cajasan">
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
export default {
  name: 'formPassword',
  data () {
    return {
      emailNew: '',
      emailNew2: ''
    }
  },
  methods: {
    verClave: function () {
      var inputClave = document.getElementById('emailNew')
      var botonClave = document.getElementsByClassName('show')

      botonClave[0].classList.toggle('activo')

      if (inputClave.type === 'password') {
        inputClave.type = 'text'
      } else {
        inputClave.type = 'password'
      }
    },

    verClave2: function () {
      var inputClave = document.getElementById('emailNew2')
      var botonClave = document.getElementsByClassName('show')

      botonClave[1].classList.toggle('activo')

      if (inputClave.type === 'password') {
        inputClave.type = 'text'
      } else {
        inputClave.type = 'password'
      }
    }
  }
}
</script>
